// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2403":"a81a21d2292a4f46","2822":"f70231fcfc2de357","5376":"1e618b257dfdd8d9","8148":"18af6f6705e4e29f"}[chunkId] + ".js";
};